module.exports = __webpack_public_path__ + "img/search.139518ce.svg";